import { styled } from '@linaria/react';
import { fonts, primitives, radius, semantic, size, space } from '../../theme/tokens';

export const Card = styled.div`
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${radius('input', 'radius-md')};

  & > * {
    box-sizing: border-box;
    min-height: calc(${primitives.size['size-1000']} + ${space['space-400']} * 2);
    padding: ${space['space-400']} ${space['space-500']};
  }

  & > *:not(:last-child) {
    border-bottom: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  }

  & label {
    font-size: ${fonts.size.xs};
    font-weight: ${fonts.weight.normal};
  }

  & input {
    border: none;
    padding: 0;
    font-size: ${fonts.size.md};
    font-weight: ${fonts.weight.normal};
    outline: none;
    border-radius: 0;
  }

  & textarea {
    border: none;
    padding: 0;
    font-size: ${fonts.size.md};
    font-weight: ${fonts.weight.normal};
    outline: none;
    border-radius: 0;
  }

  & button[aria-haspopup='listbox'] {
    border: none;
    padding: 0;
    font-size: ${fonts.size.md};
    font-weight: ${fonts.weight.normal};
    min-width: unset;
    width: 100%;
    background: transparent;
  }

  & div:has(> button[aria-haspopup='listbox']) {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  & [role='listbox'] {
    left: calc(-1 * ${space['space-500']} - ${size.stroke['stroke-default']});
    right: calc(-1 * ${space['space-500']} - ${size.stroke['stroke-default']});
    top: calc(100% + ${space['space-400']});
    border-radius: 0 0 ${radius('overlay', 'radius-md')} ${radius('overlay', 'radius-md')};
    border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  }

  & [role='listbox'] input {
    padding: ${space['space-300']} ${space['space-400']};
    border-bottom: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  }

  & [role='listbox'] [role='option'] {
    padding: ${space['space-300']} ${space['space-400']};
  }
`;
